// ============================================================
// main.js — entry point
// ============================================================
import { Game } from './Game.js';

window.addEventListener('DOMContentLoaded', async () => {
  const game = new Game();
  await game.init();

  // Expose for debugging
  window.__game = game;
});
